<article
  class="relative flex h-full min-h-[22rem] flex-col rounded-lg border border-teal-500 bg-surface-dark px-6 pt-24 sm:pt-32 pb-6 sm:px-8"
>
  <div
    aria-hidden="true"
    class="absolute -top-16 left-1/2 flex h-32 w-32 -translate-x-1/2 items-center justify-center rounded-full bg-accent"
  >
    <span
      class="font-sans text-[30px] font-bold text-white [font-feature-settings:normal] [font-variation-settings:normal]"
    >
      {{ title() }}
    </span>
  </div>

  <div class="flex flex-1 flex-col">
    <h3
      class="value-card-subtitle text-[24px] font-semibold leading-[1.12] tracking-[0.005em] text-white"
    >
      {{ subtitle() }}
    </h3>
    <p class="mt-5 text-[18px] leading-[1.22] tracking-[0.005em] text-[#D9D9D9]">
      {{ text() }}
    </p>
  </div>

  @switch (iconMode()) {
    @case ('routerLink') {
      <div class="mt-auto flex justify-end pt-8">
        <a
          [routerLink]="iconRouterLink()"
          [attr.aria-label]="iconAriaLabel()"
          class="inline-flex rounded-md border border-accent p-1.5 text-accent transition-colors hover:bg-accent/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        >
          <lucide-icon name="square-arrow-up-right" [size]="22"></lucide-icon>
        </a>
      </div>
    }
    @case ('href') {
      <div class="mt-auto flex justify-end pt-8">
        <a
          [href]="iconHref()"
          [attr.aria-label]="iconAriaLabel()"
          class="inline-flex rounded-md border border-accent p-1.5 text-accent transition-colors hover:bg-accent/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        >
          <lucide-icon name="square-arrow-up-right" [size]="22"></lucide-icon>
        </a>
      </div>
    }
    @case ('decorative') {
      <div class="mt-auto flex justify-end pt-8">
        <span
          aria-hidden="true"
          class="inline-flex rounded-md border border-accent p-1.5 text-accent"
        >
          <lucide-icon name="square-arrow-up-right" [size]="22"></lucide-icon>
        </span>
      </div>
    }
  }
</article>
